"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.344 3.75v-.705h-2.785v.706H.879c-.237 0-.482.025-.669.212-.197.198-.197.44-.197.65v6.783h1V4.75H14.92v7.44H.02v1h15.107c.482 0 .793-.301.793-.767V4.569c0-.512-.302-.818-.809-.818h-.766Zm-1.392 1.672a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6Zm-5.238 5.013c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2Zm-3-2c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M21.767 5.438v-.985h-3.069v.985H1.306c-.318 0-.644.032-.877.265-.242.244-.241.542-.24.852v10.302h1.124V6.563h21.524l-.001 11.7H0v1.125h22.954c.622 0 1.008-.37 1.008-.969V6.485c0-.391-.134-1.047-1.03-1.047h-1.165ZM11.69 15.923a3.568 3.568 0 0 1-3.564-3.564 3.568 3.568 0 0 1 3.564-3.565 3.568 3.568 0 0 1 3.564 3.565 3.567 3.567 0 0 1-3.564 3.564ZM7.002 12.36a4.694 4.694 0 0 0 4.69 4.69 4.694 4.694 0 0 0 4.688-4.69 4.694 4.694 0 0 0-4.689-4.69 4.695 4.695 0 0 0-4.689 4.69Zm13.23-4.621a1.005 1.005 0 1 1 0 2.01 1.005 1.005 0 0 1 0-2.01Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M29.022 7.25V5.938h-4.09V7.25H1.74c-.424 0-.858.043-1.169.354-.322.326-.321.723-.32 1.136v13.736h1.5V8.75H30.45l-.002 15.601H0v1.5h30.606c.829 0 1.344-.495 1.344-1.292V8.646c0-.52-.179-1.396-1.375-1.396h-1.553ZM15.59 21.231a4.757 4.757 0 0 1-4.753-4.752 4.758 4.758 0 0 1 4.752-4.753 4.757 4.757 0 0 1 4.752 4.753 4.756 4.756 0 0 1-4.752 4.752Zm-6.253-4.752a6.259 6.259 0 0 0 6.252 6.252 6.258 6.258 0 0 0 6.252-6.252 6.26 6.26 0 0 0-6.252-6.253 6.26 6.26 0 0 0-6.252 6.253Zm17.64-6.162a1.34 1.34 0 1 1 0 2.68 1.34 1.34 0 0 1 0-2.68Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M43.516 10.42V8.262h-6.133v2.156H2.61c-.553 0-1.181.037-1.62.476-.429.43-.428.962-.428 1.475v20.693h1.875V12.296c.05-.001.107-.003.173-.003h43.234V36.06H0v1.875h45.891c1.145 0 1.828-.654 1.828-1.75v-23.86c0-.869-.325-1.906-1.875-1.906h-2.328Zm-3.069 4.411a2.009 2.009 0 1 1 .001 4.018 2.009 2.009 0 0 1 0-4.018ZM23.374 31.383c-4.032 0-7.313-3.28-7.313-7.313 0-4.033 3.28-7.314 7.313-7.314 4.032 0 7.312 3.28 7.312 7.314 0 4.032-3.28 7.313-7.312 7.313Zm-9.188-7.313c0 5.066 4.122 9.188 9.188 9.188 5.066 0 9.187-4.122 9.187-9.188 0-5.067-4.121-9.189-9.187-9.189-5.066 0-9.188 4.122-9.188 9.189Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M58.021 13.892v-2.874h-8.178v2.874H3.48c-.738 0-1.575.05-2.159.635-.573.574-.572 1.282-.571 1.967v27.589h2.5V16.396a7.31 7.31 0 0 1 .23-.004h57.645a.589.589 0 0 1 .001.042V48.08H0v2.5h61.188c1.526 0 2.438-.872 2.438-2.333V16.434c0-1.159-.434-2.542-2.5-2.542h-3.105Zm-4.091 5.883a2.678 2.678 0 1 1 .001 5.357 2.678 2.678 0 0 1-.001-5.357ZM31.165 41.844c-5.376 0-9.75-4.374-9.75-9.751s4.374-9.751 9.75-9.751 9.75 4.374 9.75 9.75c0 5.378-4.374 9.752-9.75 9.752Zm-12.25-9.751c0 6.755 5.495 12.25 12.25 12.25s12.25-5.495 12.25-12.25-5.495-12.251-12.25-12.251-12.25 5.496-12.25 12.25Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCamera = function IconCamera(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Camera' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Camera"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCamera.sizes = [16, 24, 32, 48, 64];
IconCamera.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCamera;
exports.default = _default;